module.exports = __webpack_public_path__ + "img/defi.f908bcd0.png";